<template>
  <div>
    <el-row>
      <el-button-group class="pull-left">
        <el-button :disabled="!canDownload" @click="createSampleset">
          <el-tooltip class="item" effect="dark" :disabled="canDownload" placement="bottom">
            <div slot="content">
              Select one or more <em>"Contact Details"</em> from Demographics<br />filters before you can
              download a contact list.
            </div>
            <span><i class="fa fa-download"></i> Download Contact List</span>
          </el-tooltip>
        </el-button>

        <el-tooltip class="item" effect="dark" :content="displayTooltipContent" placement="bottom">
          <el-button @click="$emit('display-profiles')">
            <span v-if="!profilesVisible"> <i class="el-icon-view"></i> Display Profiles </span>
            <span v-else>
              <span><i class="fa fa-fw fa-eye-slash"></i> Hide Profiles</span>
            </span>
          </el-button>
        </el-tooltip>

        <el-dropdown v-show="false">
          <el-button>
            <i class="el-icon-message"></i> Export for Email<i
              class="el-icon-arrow-down el-icon--right"
            ></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>Constant Contact</el-dropdown-item>
            <el-dropdown-item>MailChimp</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-tooltip
          class="item"
          effect="dark"
          content="Reset all filter selections"
          placement="bottom"
        >
          <el-button @click="$emit('clear-filters')">
            <span><i class="el-icon-refresh-left"></i> Reset Filters</span>
          </el-button>
        </el-tooltip>
      </el-button-group>

      <el-button-group class="pull-right">
        <el-tooltip
          class="item"
          effect="dark"
          content="Apply previously saved filters"
          placement="bottom"
        >
          <el-button
            @click="savedQueriesVisible = true"
            type="default"
            icon="fa fa-fw fa-folder-open-o"
            >&nbsp;Load</el-button
          >
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          content="Save current filter selection"
          placement="bottom"
        >
          <el-button @click="handleSaveQuery" type="default" icon="fa fa-fw fa-floppy-o"
            >&nbsp;Save</el-button
          >
        </el-tooltip>
      </el-button-group>
    </el-row>

    <saved-query-list
      :visible="savedQueriesVisible"
      :loading="loadingSavedQueries"
      :queries="savedQueries"
      @apply-query="handleApplyQuery"
      @delete-query="$emit('delete-query', $event)"
      @close="handleCloseSavedQueries"
    />
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import SavedQueryList from '@/components/profiles/SavedQueryList';

export default {
  name: 'ProfilesDataExport',
  components: {
    SavedQueryList,
  },
  computed: {
    displayTooltipContent() {
      return this.profilesVisible
        ? 'Hide the profile browser'
        : 'View the profiles that meet your search criteria';
    },
  },
  data: () => ({
    savedQueriesVisible: false,
  }),
  props: {
    profilesVisible: {
      type: Boolean,
      default: false,
    },
    canDownload: {
      type: Boolean,
      default: false,
    },
    loadingSavedQueries: {
      type: Boolean,
      default: true,
    },
    savedQueries: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleCloseSavedQueries() {
      this.savedQueriesVisible = false;
    },
    handleApplyQuery(queryId) {
      this.$emit('apply-query', queryId);
      this.savedQueriesVisible = false;
    },
    handleSaveQuery() {
      this.$prompt('Please enter a meaningful description of your filter', 'Save Filter', {
        confirmButtonText: 'Save',
        cancelButtonText: 'Cancel',
        inputErrorMessage: 'Please enter a description',
        inputValidator: value => !isEmpty(value),
      }).then(title => this.$emit('save-query', title));
    },
    createSampleset() {
      this.$prompt('Please enter a description of your sample', 'Download Contact List', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputErrorMessage: 'Please enter a description',
        inputValidator: value => !isEmpty(value),
      }).then(({ value }) => {
        this.$emit('download', value);
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// ProfilesDataExport.vue?778f4d13